import Api from "./Api.service"

export default class DisponibilidadService {

    static Obtener() {
        return Api.get('disponibilidad');
    }
    static ObtenerDispoComiSemestre(semestre) {
        return Api.get(`disponibilidad/comision/semestre/${semestre}`);
    }
    static ObtenerDispoComiSemestreDetalle(semestre,docenteId) {
        return Api.get(`disponibilidad/comision/semestre/detalle/${semestre}/${docenteId}`);
    }
    static Agregar(dispo) {
        return Api.post('disponibilidad', dispo);
    }

    static Eliminar(id) {
        return Api.delete(`disponibilidad/${id}`);
    }
    static Desactivar(id,docenteId) {
        return Api.delete(`disponibilidad/${id}/${docenteId}`);
    }
    static ReporteDispoComiXSemestre(id) {
            return Api.getBlob(`disponibilidad/reporte/${id}`);
    }
}